import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Supplier\UpdateSupplierController::__invoke
* @see app/Http/Controllers/Supplier/UpdateSupplierController.php
* @route '/api/supplier/{supplier}'
*/
const UpdateSupplierController = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateSupplierController.url(args, options),
    method: 'put',
})

UpdateSupplierController.definition = {
    methods: ["put"],
    url: '/api/supplier/{supplier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Supplier\UpdateSupplierController::__invoke
* @see app/Http/Controllers/Supplier/UpdateSupplierController.php
* @route '/api/supplier/{supplier}'
*/
UpdateSupplierController.url = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier: typeof args.supplier === 'object'
        ? args.supplier.id
        : args.supplier,
    }

    return UpdateSupplierController.definition.url
            .replace('{supplier}', parsedArgs.supplier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Supplier\UpdateSupplierController::__invoke
* @see app/Http/Controllers/Supplier/UpdateSupplierController.php
* @route '/api/supplier/{supplier}'
*/
UpdateSupplierController.put = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateSupplierController.url(args, options),
    method: 'put',
})

export default UpdateSupplierController